import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

const Tags = ({ handleTagChange,tag }) => {
  return (
    <div>
      <Autocomplete
        size="small"
        multiple
        limitTags={window.innerWidth > 600 ? 7 : 2}
        id="tags-filled"
        value={tag}
        onChange={handleTagChange}
        options={[]}
        freeSolo
        renderInput={(params) => <TextField {...params} label="Tags" />}
      />
    </div>
  );
};

export default Tags;
